<template>
	<div class="alert" :class="[seType,setPosition]">
		<button v-if="!!close" type="button" class="close" @click="handleClose"><span>&times;</span></button> {{content}}
		<slot></slot>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			content: String,
			close: Boolean,
			type: String,
			position:String
		},
		data() {
			return {}
		},
		methods: {
			handleClose(event) {
				this.$emit('close', event);
			}
		},
		mounted: function() {
			this.$nextTick(function() {

			})
		},
		computed: {
			seType() {
				return this.type ? "alert-" + this.type : 'alert-warning';
			},
			setPosition(){
				return this.position?"fixed fix"+this.position:"";
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../assets/lib/css.less";
	.alert {
		.unbdr;
		&.fixed {
			position: fixed;
			left:0;
			right: 0;
			z-index:999;
			opacity:.95;
			.mgb(0);
			/*&.full{
				left:0;
			}*/
			&.fixtop {
				top: 0;
			}
			&.fixbottom {
				bottom: 0;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// alert.vue?ba263a66